import React, { Component } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import PageMetadata from '../components/Generic/PageMetadata';
import { contentType, contentfulConstant } from '../constants/global';
import config from '../config';
import { getSrcSetW } from '../utils/ImageManager';
import { defaultLangKey } from '../constants/languages';
import getInitialData from '../utils/helpers/initialDataHelper';
import DOMIdentifier from '../utils/domIdentifier';
import PGDataLayer from '../components/Generic/PGDataLayer/PGDataLayer';
import { renderSection } from '../utils/uiHelper';
import LazyLoad from 'react-lazy-load';
import { SEO, SEOWebsite } from '../components/Brand/SEO';
import PopUp from '../components/Brand/Popup/index';
const HomeAlert = PopUp;


class HomePage extends Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    homePageData: PropTypes.oneOfType([PropTypes.object]).isRequired,
    router: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  static async getInitialProps({ query }) {
    const { locale } = query;
    let homePageData = await getInitialData(
      contentfulConstant,
      contentType.homePage,
      locale || defaultLangKey,
      query
    );
    return {
      homePageData: homePageData.data || {},
      pageContext: query,
    };
  }

  state = {
    showAlert: false,
    screenWidth:null,
  };

  
  componentDidMount() {
    
    if(typeof window !='undefined'){
    window.addEventListener("resize",this.handleResize);
    this.setState({screenWidth:window.innerWidth})    
  }
    DOMIdentifier.addClassToBody('homepage');
    setTimeout(() => {
      this.toggleAlert(true);
    }, 2000);
    this.alertListener();
  }
  componentWillUnmount() {
    DOMIdentifier.removeClassToBody('homepage');
  }
  handleResize=()=>{
    this.setState({screenWidth:window.innerWidth})
}
  toggleAlert = bool => {
    this.setState({ showAlert: bool });
  };

  alertListener() {
    window.addEventListener('click', e => {
      if (
        document.getElementById('home-alert') &&
        !document.getElementById('home-alert').contains(e.target)
      )
        this.toggleAlert(false);
    });
  }

  render() {
    const { homePageData, pageContext, router } = this.props;
    const { showAlert,screenWidth } = this.state;
    let pageData = homePageData.homePageCollection.items[0];
    return (
      <>
        <Head>
          <link
            rel="preload"
            href={getSrcSetW(
              pageData.pageContentCollection.items[0].sectionContentCollection
                .items[0]?.imageSet?.desktopImage?.url,
              640
            ).replace(/q_auto:eco,/g, '')}
            as="image"
          />
        </Head>
        <React.Fragment>
          {typeof window !== 'undefined' &&
          window.navigator.userAgent.indexOf('Moto G (4)') == -1 &&
          window.navigator.userAgent.indexOf('Speed Insights') == -1 &&
          window.navigator.userAgent.indexOf('Chrome-Lighthouse') == -1 
            ? pageData &&
              pageData.pageMetaData && (
                <PGDataLayer
                  locale={pageContext.locale}
                  pageType={contentType.homePage}
                  path={router.asPath}
                  title={
                    pageData.pageMetaData && pageData.pageMetaData.pageTitle
                  }
                />
              )
            : ''}
          {pageData.pageMetaData && (
            <PageMetadata
              title={pageData.pageMetaData.pageTitle}
              metaTitle={pageData.pageMetaData.metaTitle}
              metaDescription={
                pageData.pageMetaData.metaDescription &&
                pageData.pageMetaData.metaDescription
              }
              orgTitle={pageData.pageMetaData.openGraphPageTitle}
              orgDescription={pageData.pageMetaData.openGraphDescription}
              metaKeywords={
                pageData.pageMetaData.metaKeywords &&
                pageData.pageMetaData.metaKeywords
              }
            />
          )}
          <SEO locale={pageContext.locale} />
          <SEOWebsite locale={pageContext.locale} />
          {pageData &&
            pageData.pageContentCollection &&
            pageData.pageContentCollection.items.map((sectionItem, index) => {
             if (index === 0) {
              return (renderSection(sectionItem, pageContext, 0));
             }else if(index !== 0){
              return (
                <LazyLoad offset={-50}>
                  <>
                  {renderSection(sectionItem, pageContext, index)}
                  </>
                </LazyLoad>
              );
             }
            })}
          {!config.registrationDisabled && (
          <HomeAlert
            alertData={homePageData.homePageCollection.items[0].homeAlert}
            showAlert={showAlert}
            toggleAlert={this.toggleAlert}
            screenWidth={screenWidth}
          />
)}
          {pageData.mobilePopUp &&  <PopUp popupdata={pageData.mobilePopUp} widthVar={screenWidth} />}
        </React.Fragment>
      </>
    );
  }
}
// NextJS has a different routing structure. We wrap all pages components with withRouter HOC
// So that they receive the router prop which is almost equivalent to the location prop in gatsby
export default withRouter(HomePage);
